import { successColor } from '@zego/theme';

import generateTintTheme from './generateTintTheme';

export default generateTintTheme(successColor(4));
